import apiClient from '../api/apiClient';

const BASE = '/api/v1/admin/suppliers';

const stripEmpty = (obj) =>
  Object.fromEntries(
    Object.entries(obj).filter(([, v]) => v !== '' && v !== null && v !== undefined)
  );

function unwrap(res) {
  const body = res?.data;
  if (body && typeof body === 'object' && 'data' in body) return body.data;
  return body;
}

const multipartConfig = {
  transformRequest: [
    (data, headers) => {
      if (typeof FormData !== 'undefined' && data instanceof FormData) {
        if (headers?.delete) headers.delete('Content-Type');
        else if (headers) {
          delete headers['Content-Type'];
          delete headers['content-type'];
        }
      }
      return data;
    },
  ],
};

const supplierService = {
  listSuppliers: async (params = {}) => {
    const { signal, ...queryParams } = params;
    const response = await apiClient.get(BASE, {
      params: stripEmpty({ page: 1, limit: 100, ...queryParams }),
      signal,
    });
    const d = unwrap(response);
    return {
      suppliers: d?.suppliers ?? [],
      pagination: d?.pagination ?? null,
    };
  },

  getOnboardingStatus: async (supplierId) => {
    const response = await apiClient.get(`${BASE}/${supplierId}/onboarding-status`);
    return unwrap(response);
  },

  /** Step 1 — creates supplier record; returns payload that should include id / user_id */
  step1Pan: async (payload) => {
    const response = await apiClient.post(`${BASE}/step1-pan`, payload);
    return unwrap(response);
  },

  step2Personal: async (supplierId, payload) => {
    const response = await apiClient.patch(`${BASE}/${supplierId}/step2-personal`, payload);
    return unwrap(response);
  },

  step3Bank: async (supplierId, payload) => {
    const response = await apiClient.patch(`${BASE}/${supplierId}/step3-bank`, payload);
    return unwrap(response);
  },

  uploadBankMismatchCheque: async (supplierId, formData) => {
    const response = await apiClient.post(
      `${BASE}/${supplierId}/bank-mismatch-cheque`,
      formData,
      multipartConfig
    );
    return unwrap(response);
  },

  step4Demat: async (supplierId, payload) => {
    const response = await apiClient.patch(`${BASE}/${supplierId}/step4-demat`, payload);
    return unwrap(response);
  },

  step5UploadCml: async (supplierId, formData) => {
    const response = await apiClient.post(`${BASE}/${supplierId}/step5-upload`, formData, multipartConfig);
    return unwrap(response);
  },
};

export default supplierService;
